module.exports = __webpack_public_path__ + "media/images/home/flow_r_index_4-c639c87c095a85f46ba482c3438f4595.svg";